var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('output-dialog',{ref:"printDlg",attrs:{"aspectRatio":883/1000,"background":require('@/assets/img/EnglishModel.jpg'),"fields":_vm.fields,"pages":_vm.pages,"filename":"EnglishModel.pdf","orientation":"portrait","title":"取引先用 登録用紙（英語）"}})}
var staticRenderFns = []

export { render, staticRenderFns }